export const TID = {
  // Navigation
  navLogo: "nav-logo",
  navHome: "nav-home",
  navEvents: "nav-events",
  navExperiences: "nav-experiences",
  navDirectory: "nav-directory",
  navGuides: "nav-guides",
  navConcierge: "nav-concierge",
  navLogin: "nav-login-btn",
  navSignup: "nav-signup-btn",
  navDashboard: "nav-dashboard",
  navLogout: "nav-logout-btn",
  navMobileToggle: "nav-mobile-toggle",

  // Home
  heroSearch: "hero-search-input",
  heroCta: "hero-cta-btn",
  heroCategory: (c) => `hero-category-${c}`,
  featuredEventCard: (id) => `featured-event-${id}`,
  featuredExpCard: (id) => `featured-exp-${id}`,
  featuredGuideCard: (id) => `featured-guide-${id}`,

  // Events
  eventCard: (id) => `event-card-${id}`,
  eventCategoryFilter: (c) => `event-cat-${c}`,
  eventSearchInput: "event-search",
  eventBookBtn: "event-book-btn",

  // Experiences
  expCard: (id) => `exp-card-${id}`,
  expCategoryFilter: (c) => `exp-cat-${c}`,
  expBookBtn: "exp-book-btn",

  // Directory
  bizCard: (id) => `biz-card-${id}`,
  bizCategoryFilter: (c) => `biz-cat-${c}`,

  // Guides
  guideCard: (id) => `guide-card-${id}`,

  // Concierge
  conciergeInput: "concierge-input",
  conciergeSend: "concierge-send-btn",
  conciergeMessage: (i) => `concierge-msg-${i}`,
  conciergeFab: "concierge-fab",
  tripPlannerForm: "trip-planner-form",
  tripPlannerSubmit: "trip-planner-submit-btn",
  tripPlannerResult: "trip-planner-result",

  // Auth
  authEmailInput: "auth-email-input",
  authPasswordInput: "auth-password-input",
  authNameInput: "auth-name-input",
  authSubmitBtn: "auth-submit-btn",
  authGoogleBtn: "auth-google-btn",
  authSwitchLink: "auth-switch-link",

  // Favorites
  favBtn: (id) => `fav-btn-${id}`,

  // Dashboard
  dashSaved: "dashboard-saved",
  dashItineraries: "dashboard-itineraries",

  // Payments
  paymentSuccess: "payment-success",
  paymentCancel: "payment-cancel",
};

export default TID;
